<template>
  <el-card class="plan-card">
    <div>
      <el-row>
        <span class="title">计划名称：{{item.NAME}}</span>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="4">
          <div>
            <span class="column-label"> 创建人：</span>
            <span class="column-value">{{item.CREATEUSERNAME}}</span>
          </div>
        </el-col>
        <el-col :span="3">
          <div>
            <span class="column-label">状态：</span>
            <el-tag size="small"
                    :type="item.PLANSTATE|planStateTypeFormater">{{item.PLANSTATENAME}}</el-tag>
          </div>
        </el-col>
        <el-col :span="5">
          <div>
            <span class="column-label">任务占比：</span>
            <el-progress :percentage="item.PERCENTAGE"
                         :text-inside="true"
                         class="progress-width"
                         style="display:inline-block"
                         :stroke-width="21"
                         status="success"></el-progress>
          </div>
        </el-col>

        <el-col :span="6">
          <div>
            <span class="column-label">预计开始时间：</span>
            <span class="column-value">{{item.BEGINTIME|planTimeFormater}}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <span class="column-label">预计结束时间：</span>
            <span class="column-value">{{item.ENDTIME|planTimeFormater}}</span>
          </div>
        </el-col>
      </el-row>
      <p v-html="item.MEMO"></p>
      <el-row type="flex"
              justify="end"
              :gutter="20">
        <el-button type="primary"
                   v-show="item.PLANSTATE===0"
                   size="medium"
                   @click="beginWorkPlan()">开始</el-button>
        <el-button type="success"
                   v-show="isCreateUser(item.CREATEUSERID)"
                   size="medium"
                   @click="editWorkPlan()">编辑</el-button>
        <el-button type="success"
                   v-show="item.PLANSTATE===1"
                   size="medium"
                   @click="completeTaskPlan()">完成</el-button>
        <el-button v-show="item.PLANSTATE===1&&item.ISDELAY"
                   size="medium"
                   @click="delayPlanProcess()">申请延期</el-button>
      </el-row>
      <DelayApply ref="delayControl"
                  @refershSource="refershSource"></DelayApply>
      <SideTagsAddPlan ref="sideTagsAddPlan"
                       :mainId="item.MAINID"
                       @successed="refershSource"></SideTagsAddPlan>
    </div>
  </el-card>
</template>

<script>
import {
  CompleteTaskPlan,
  ProccessTaskPlan
} from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
import SideTagsAddPlan from "./SideTagsAddPlan";
import DelayApply from "@/views/task/taskDelay/DelayApply.vue";
const cookieUser = getToken();
const person = {
  ID: cookieUser.userId,
  NAME: cookieUser.realName,
  DEPTID: cookieUser.departmentId,
  DEPTNAME: cookieUser.departmentName,
  COMPANYID: cookieUser.companyId,
  COMPANYNAME: cookieUser.companyName
};
export default {
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  components: {
    DelayApply,
    SideTagsAddPlan
  },
  filters: {
    planTimeFormater: function(time) {
      return time ? time.replace("T", " ").substr(0, 16) : "";
    },
    planStateFormater: function(val) {
      switch (val) {
        case 0:
          return "未开始";
        case 1:
          return "执行中";
        case 2:
          return "已完成";
        default:
          return "";
      }
    },
    planStateTypeFormater: function(val) {
      switch (val) {
        case 0:
          return "";
        case 1:
          return "success";
        case 2:
          return "warning";
        default:
          return "";
      }
    }
  },
  methods: {
    refershSource() {
      this.$emit("refershSource");
    },
    isCreateUser(val) {
      return val === person.ID;
    },
    //延期任务进度
    delayPlanProcess() {
      this.$refs.delayControl.loadWorkPlan(this.item, 0);
    },
    //编辑任务进度
    editWorkPlan() {
      this.$refs.sideTagsAddPlan.loadPlan(this.item);
    },
    //开始工作计划
    beginWorkPlan() {
      if (this.item) {
        ProccessTaskPlan(this.item, person).then(result => {
          if (result.ResultCode > 0) {
            this.$message.success("开始工作计划");
            this.refershSource();
          } else {
            this.$message.error(result.MsgInfo);
          }
        });
      }
    },
    //完成工作计划
    completeTaskPlan() {
      if (this.item) {
        CompleteTaskPlan(this.item, person).then(result => {
          if (result.ResultCode > 0) {
            this.$message.success("完成工作计划");
            this.refershSource();
          } else {
            this.$message.error(result.MsgInfo);
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.plan-card {
  margin-bottom: 10px;
}
.header {
  padding: 0 20px;
  height: 50px;
  font-size: 14px;
  background-color: #e1ebf7;
}
.header-title {
  font-weight: bold;
  font-size: 18px;
}
.title {
  margin-top: 5px;
  font-size: 16px;
  line-height: 30px;
  text-align: left;
  max-height: 35px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card-content .el-row {
  margin-bottom: 10px;
}
.column-label {
  color: #999999;
  font-size: 14px;
}
.column-value {
  font-size: 14px;
}
.progress-width {
  width: 100px;
}
</style>